// Single locale-formatting seam. Hard-codes "en-US" today (matching prior behavior);
// future i18n flips LOCALE (or reads it from context) in one place.
const LOCALE = "en-US";

/** User-facing integer/count. Was: n.toLocaleString(). */
export const formatNumber = (n: number): string => (n ?? 0).toLocaleString(LOCALE);

/** Short absolute date, e.g. "Jul 10, 2026". Was: toLocaleDateString("en-US", {month,day,year}). */
export const formatDate = (ms: number): string =>
  new Date(ms).toLocaleDateString(LOCALE, { month: "short", day: "numeric", year: "numeric" });

/** Relative "N days ago" — moved verbatim from trackService.formatRelativeDays. */
export const formatRelative = (ms: number): string => {
  if (!ms) return "";
  const days = Math.floor((Date.now() - ms) / 86_400_000);
  if (days <= 0) return "today";
  if (days === 1) return "yesterday";
  if (days < 30) return `${days} days ago`;
  const months = Math.floor(days / 30);
  return `${months} month${months > 1 ? "s" : ""} ago`;
};
